module.exports = __webpack_public_path__ + "static/assets/a61fc8393abec3c0d1e813fc01f252ee.mp3";